import React, { useContext } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../views/authentication/auth/UserContext';
import { getDefaultRouteForRole } from './defaultRouteByRole';

const RoleBasedRedirect = () => {
  const { user } = useContext(UserContext);
  const storedRole = localStorage.getItem('userRole');
  const role = user?.role || storedRole;

  if (!role) {
    return (
      <Box sx={{ height: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  const target = getDefaultRouteForRole(role);
  return <Navigate to={target} replace />;
};

export default RoleBasedRedirect;
